export default "__VITE_ASSET__BmldFHpZ__"